import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DataTable } from '../../../web/src/components/data-table.jsx';
import { translateColumns } from '../../../web/src/locale/translate-columns.js';
import { TRANSACTION_COLUMNS } from './../../../shared-site-web/screens/transaction-table.js';
import { useSiteLang } from '../layout/use-site-lang.js';
import { getMockTaggedTransactions } from './mock-data/mock-tagged-transactions.js';
import { inertActions, pairRow } from './mock-table.jsx';

// On mobile only the top-priority columns render, so bump tags up to
// priority 1 and drop the date column — the tag pills stay visible.
/** @type {Record<string, number>} */
const TAG_COLUMN_PRIORITIES = {
	date: 3,
	accountName: 2,
	type: 1,
	amount: 1,
	currency: 3,
	tags: 1,
	description: 2,
};

/**
 * The tagged transactions feed for the tags use case. Same real DataTable as
 * the app, but with the tags column prioritised so it shows on small screens.
 * @returns {JSX.Element}
 */
export function TagsCard() {
	const { t } = useTranslation();
	const lang = useSiteLang();
	const columns = useMemo(() => {
		const cols = TRANSACTION_COLUMNS.map((c) => ({ ...c, priority: TAG_COLUMN_PRIORITIES[c.key] ?? c.priority }));
		return translateColumns(cols, t);
	}, [t]);
	return (
		<DataTable
			columns={columns}
			rows={getMockTaggedTransactions(lang)}
			title={t('page.title.transactions')}
			emptyMessage={t('empty.noTransactions')}
			renderRow={pairRow}
			renderActions={inertActions(t)}
		/>
	);
}
